module.exports = __webpack_public_path__ + "img/electrolux_logo_blue.532dbd46.jpg";